module.exports = __webpack_public_path__ + "static/media/conflict.4fd7f426.jpg";